import { Pressable, StyleSheet, Text, View } from 'react-native';
import { colors, control, fontFamily, radii, spacing } from '~/ui/tokens';

interface TabsProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

export function Tabs<T extends string>({ options, value, onChange }: TabsProps<T>) {
  return (
    <View style={styles.track}>
      {options.map((option) => {
        const active = option.value === value;
        return (
          <Pressable
            key={option.value}
            accessibilityRole="tab"
            accessibilityState={{ selected: active }}
            onPress={() => onChange(option.value)}
            style={[styles.tab, active && styles.tabActive]}
          >
            <Text style={[styles.label, active && styles.labelActive]}>{option.label}</Text>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  track: {
    flexDirection: 'row',
    backgroundColor: colors.lineSoft,
    borderRadius: radii.full,
    padding: spacing(0.5),
    alignSelf: 'flex-start',
  },
  tab: {
    paddingVertical: spacing(1),
    paddingHorizontal: spacing(2.5),
    borderRadius: radii.full,
  },
  tabActive: {
    backgroundColor: colors.brand,
  },
  label: {
    fontFamily: fontFamily.semibold,
    ...control.secondaryCta,
    color: colors.inkSoft,
  },
  labelActive: {
    color: colors.white,
  },
});
